import { heritageInterior } from '@/assets/images';

export default function Heritage() {
  return (
    <section id="sobre" className="relative py-28 md:py-40 bg-ink-900 text-cream-50 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heritageInterior}
          alt="Interior de la boutique SANO Moda en Llíria a lo largo de su historia"
          title="SANO Moda · Historia de la boutique en Llíria, Valencia"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-ink-900/72"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-ink-900 via-ink-900/10 to-ink-900"></div>
      </div>
      <div className="relative max-w-4xl mx-auto px-6 md:px-10 text-center">
        <div className="flex justify-center mb-10">
          <span
            role="img"
            aria-label="SANO Moda · Llíria, Valencia"
            className="logo-wordmark logo-white block w-[220px] md:w-[320px] h-[66px] md:h-[96px]"
          />
        </div>
        <p className="text-[11px] tracking-widest-xl text-silver-200 mb-8">DESDE LOS 80</p>
        <h2 className="font-display text-silver-50 text-4xl md:text-6xl lg:text-7xl leading-tight mb-10">
          Más de 38 años<br />a tu lado
        </h2>
        <div className="w-16 h-px bg-silver-300/50 mx-auto mb-10"></div>
        <p className="text-silver-100 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-6">
          Durante estos más de 38 años, SANO ha formado parte del día a día de Llíria, ofreciendo moda, estilo y una atención cercana y personalizada.
        </p>
        <p className="text-silver-200 text-sm md:text-base leading-relaxed max-w-2xl mx-auto italic font-display">
          Trayectoria, confianza y cercanía en cada prenda que elegimos para ti.
        </p>

        <div className="mt-16 grid grid-cols-3 gap-6 max-w-2xl mx-auto">
          {[
            { n: '38+', l: 'AÑOS DE HISTORIA' },
            { n: '∞', l: 'ESTILO ATEMPORAL' },
            { n: '1', l: 'TIENDA EN LLÍRIA' },
          ].map((s) => (
            <div key={s.l} className="border-t border-silver-300/30 pt-6">
              <div className="font-display text-silver-50 text-3xl md:text-4xl mb-2">{s.n}</div>
              <div className="text-[10px] tracking-widest text-silver-300">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}